import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Package, Menu } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";

export const Navbar = () => {
  const { user, signOut } = useAuth();
  const { isAdmin } = useAdminStatus();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
      setOpen(false);
    } catch (error) {
      // Log only in development to prevent info leakage
      if (import.meta.env.DEV) {
        console.error("Error signing out:", error);
      }
    }
  };

  const NavLinks = ({ mobile = false }: { mobile?: boolean }) => {
    const linkClass = mobile 
      ? "w-full justify-start text-lg py-3" 
      : "";
    
    const handleLinkClick = () => {
      if (mobile) setOpen(false);
    };

    return (
      <>
        {user ? (
          <>
            <Link to="/dashboard" onClick={handleLinkClick}>
              <Button variant="ghost" className={linkClass}>Dashboard</Button>
            </Link>
            <Link to="/tracking" onClick={handleLinkClick}>
              <Button variant="ghost" className={linkClass}>Tracking</Button>
            </Link>
            <Link to="/settings" onClick={handleLinkClick}>
              <Button variant="ghost" className={linkClass}>Settings</Button>
            </Link>
            {isAdmin && (
              <Link to="/admin" onClick={handleLinkClick}>
                <Button variant="ghost" className={linkClass}>Admin</Button>
              </Link>
            )}
            <Button 
              variant={mobile ? "outline" : "outline"} 
              onClick={handleSignOut}
              className={mobile ? "w-full mt-4" : ""}
            >
              Sign Out
            </Button>
          </>
        ) : (
          <Link to="/auth" onClick={handleLinkClick}>
            <Button variant="outline" className={mobile ? "w-full" : ""}>Sign In</Button>
          </Link>
        )}
      </>
    );
  };

  return (
    <nav className="border-b bg-card/50 backdrop-blur-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2 font-bold text-xl">
          <Package className="w-6 h-6 text-primary" />
          <span>Returnify</span>
        </Link>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-4">
          <NavLinks />
        </div>

        {/* Mobile Navigation */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon">
              <Menu className="h-6 w-6" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[280px] sm:w-[320px]">
            <div className="flex flex-col gap-2 mt-8">
              <NavLinks mobile />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
};
